<template>
  <fragment>
    <c-button-link
      theme="primary"
      :icon="icon"
      data-toggle="tooltip"
      :title="tooltipTitle"
      @click="copy"><slot></slot></c-button-link>
  </fragment>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    tooltipTitle: {
      type: String,
      default: 'Copy to Clipboard'
    },
    icon: {
      type: String,
      default: 'fa-copy'
    }
  },
  methods: {
     copy() {
       let $temp = $("<input>")

       $("body").append($temp)
       $temp.val(this.text).select()

       document.execCommand("copy")
       $temp.remove()

       notifier.success('Success', 'Copied to clipboard')
     }
  }
}
</script>
